import { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8001/api/v1";

export default function CambiarPassword({ onCambio }) {
  const [actual, setActual] = useState("");
  const [nuevo, setNuevo] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  async function handleCambio() {
    if (nuevo !== confirmar) {
      setError("Las contraseñas nuevas no coinciden");
      return;
    }
    if (nuevo.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    setCargando(true);
    setError(null);
    try {
      await axios.post(
        API + "/auth/cambiar-password",
        { password_actual: actual, password_nuevo: nuevo },
        { withCredentials: true }
      );
      onCambio();
    } catch (e) {
      setError("Error al cambiar contraseña. Verifica tu contraseña actual.");
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="ZLinkINT" className="h-10 w-10 object-cover rounded-lg mx-auto mb-3" />
          <h1 className="text-2xl font-bold text-white">🔐 Cambio de Contraseña</h1>
          <p className="text-yellow-400 mt-2 text-sm">
            Por seguridad debes cambiar tu contraseña antes de continuar
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Contraseña actual</label>
            <input
              type="password"
              value={actual}
              onChange={e => setActual(e.target.value)}
              className="w-full bg-gray-700 text-white border border-gray-600 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Nueva contraseña</label>
            <input
              type="password"
              value={nuevo}
              onChange={e => setNuevo(e.target.value)}
              className="w-full bg-gray-700 text-white border border-gray-600 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Confirmar nueva contraseña</label>
            <input
              type="password"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              className="w-full bg-gray-700 text-white border border-gray-600 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>

          {error && (
            <div className="bg-red-900 border border-red-700 text-red-300 rounded-lg p-3 text-sm">
              {error}
            </div>
          )}

          <button
            onClick={handleCambio}
            disabled={cargando}
            className="w-full bg-yellow-600 hover:bg-yellow-700 disabled:opacity-50 text-white font-semibold py-3 rounded-lg transition-colors"
          >
            {cargando ? "Cambiando..." : "Cambiar Contraseña"}
          </button>
        </div>
      </div>
    </div>
  );
}